import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <App />
);

// Service worker DISABLED 2026-05-11 — the prior CRA-style SW caused stale
// SPA bundles to stick around in Safari (Safari is much stickier about
// SW lifecycle than Chrome), producing blank-page bugs on
// mchatai.com/leaderboards/<slug> after deploys. Even with the v4 explicit-
// allowlist policy, older installs of the SW could still serve cached
// /index.html that referenced dead bundle hashes.
//
// We now (a) never register a SW from the SPA, and (b) explicitly unregister
// any SW that was previously installed on the user's browser. On the server
// side, /service-worker.js is now a self-uninstalling stub so even users who
// never reload this SPA bundle (e.g. always land directly on /u/<slug>/)
// eventually shed the stale SW the next time their browser refreshes it.
//
// Filed: gotchas_spa_service_worker_safari_stale.md
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister().catch(() => {}));
  }).catch(() => {});
}

//import { studioTheme } from "./ui-components";
//import { AmplifyProvider } from '@aws-amplify/ui-react';


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
